module.exports = __webpack_public_path__ + "img/background-dotted.9f5404a3.png";